import { CRM_WEB_PAGES_URLS } from '../CRM_WEB_PAGES_URLS';
import { PATIENT_WEB_PAGES_URLS } from '../PATIENT_WEB_PAGES_URLS';
import { defaultOrgConfig } from './default';
import { usStates } from '../data';
export const trugenics = defaultOrgConfig(
  'trugenics',
  'Trugenics',
  'trugenics.com'
);
trugenics.patientWebAppLayout.logo.img =
  'https://trugenics.com/wp-content/uploads/2024/10/Trugenics-Logo.png';
trugenics.patientWebAppLayout.availableStates.us = usStates.filter(
  ({ code }) => code !== 'OTHER'
);
trugenics.blockCreateOrderOnFailedPayment = true;
trugenics.patientWebAppLayout.mainMenu.push({
  title: 'Subscriptions',
  link: PATIENT_WEB_PAGES_URLS.subscriptions.list,
  svg: 'assets/icons/orders.svg',
  roles: ['*']
});
trugenics.patientWebAppLayout.colors = {
  primaryColor: '#18c6c2',
  secondaryColor: '#ffffff'
};
trugenics.patientWebAppLayout.privacyPolicyUrl =
  'https://trugenics.com/general-privacy-policy/';
trugenics.patientWebAppLayout.termsOfUseUrl =
  'https://trugenics.com/terms-of-use/';
trugenics.patientWebAppLayout.shopUrl = 'https://trugenics.com/';
trugenics.patientWebAppLayout.logo.img =
  'https://trugenics.com/wp-content/uploads/2024/10/Trugenics-Logo.png';
trugenics.patientWebAppLayout.gtm.id = 'GTM-NXHXHPH9';
trugenics.crmWebAppLayout.mainMenu = [
  {
    title: 'Leads',
    link: CRM_WEB_PAGES_URLS.leads.list,
    icon: 'fa-regular fa-address-book',
    roles: ['*']
  },

  {
    title: 'Tasks',
    link: CRM_WEB_PAGES_URLS.tasks.list,
    icon: 'fa-solid fa-list-check',
    roles: ['*']
  },
  {
    title: 'Segments',
    link: CRM_WEB_PAGES_URLS.segment.list,
    icon: 'fa-solid fa-table-columns',
    roles: ['*']
  },
  {
    title: 'Store Manager',
    link: '',
    icon: 'fas fa-shop',
    roles: ['admin', 'developer', 'owner'],
    items: [
      {
        title: 'Products',
        link: CRM_WEB_PAGES_URLS.products.list,
        icon: 'fas fa-product'
      },
      {
        title: 'Categories',
        link: CRM_WEB_PAGES_URLS.productCategories.list,
        icon: 'fas fa-product'
      }
    ]
  },
  {
    title: 'Admin',
    link: '',
    icon: 'fas fa-user-cog',
    roles: ['admin', 'developer', 'owner'],
    items: [
      {
        title: 'Workflows',
        link: CRM_WEB_PAGES_URLS.workflows.list,
        icon: 'fas fa-code-branch'
      },
      {
        title: 'Templates',
        link: CRM_WEB_PAGES_URLS.emailTemplates.list,
        icon: 'fas fa-palette'
      },
      {
        title: 'Users',
        link: CRM_WEB_PAGES_URLS.users.list,
        icon: 'fas fa-lock'
      },
      {
        title: 'Settings',
        link: CRM_WEB_PAGES_URLS.settings.base,
        icon: 'fa-solid fa-sliders'
      }
    ]
  }
];
